<uni-button
  [isMargin]="false"
  [style]="'secondary'"
  (click)="onTopup()"
>
  {{ 'navigation.payments.topup' | translate }}
</uni-button>
